export default "__VITE_ASSET__Biu0vu1R__"